"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActionTypeEnum = void 0;
let ActionTypeEnum = exports.ActionTypeEnum = /*#__PURE__*/ function(ActionTypeEnum) {
    ActionTypeEnum["Filter"] = "Filter";
    ActionTypeEnum["LoadMore"] = "LoadMore";
    ActionTypeEnum["Sort"] = "Sort";
    return ActionTypeEnum;
}({});
